<div class="" id="mobileMenuContainer">
  <div class="menuMobileItemGroup" *ngIf="currentView == 'rootMobile'">
    <div
      class="display-flex-space-between flex-align-center menuMobileItem"
      (click)="
        action(
          'planReviewMobile',
          'rootMobile',
          'PARTECIPANT_LTI.SIDEBAR.PLAN_REVIEW'
        )
      "
    >
      <div class="">
        {{ 'PARTECIPANT_LTI.SIDEBAR.PLAN_REVIEW' | translate | titlecase }}
      </div>
      <div class="display-flex-right flex-align-center">
        <i
          class="fa fa-info-circle fa-2x footer-default"
          *ngIf="
            !currentPlan.termsConditions ||
            !currentPlan.myLtiFormMobile ||
            !currentPlan.vexatiousClauses
          "
        ></i>
        <div style="width: 10px"></div>
        <i class="fa fa-angle-right fa-2x"></i>
      </div>
    </div>
    <div
      class="display-flex-space-between flex-align-center menuMobileItem"
      (click)="
        action(
          'bonusSimulationMobile',
          'rootMobile',
          'PARTECIPANT_LTI.SIDEBAR.BONUS_SIMULATION'
        )
      "
    >
      <div class="">
        {{ 'PARTECIPANT_LTI.SIDEBAR.BONUS_SIMULATION' | translate | titlecase }}
      </div>
      <i class="fa fa-angle-right fa-2x"></i>
    </div>
    <div
      class="display-flex-space-between flex-align-center menuMobileItem"
      (click)="
        action('resultsMobile', 'rootMobile', 'PARTECIPANT_LTI.SIDEBAR.RESULTS')
      "
    >
      <div class="">
        {{ 'PARTECIPANT_LTI.SIDEBAR.RESULTS' | translate | titlecase }}
      </div>
      <i class="fa fa-angle-right fa-2x"></i>
    </div>
  </div>

  <div *ngIf="currentView == 'planReviewMobile'">
    <div class="" id="scrollMenu">
      <div class="menuMobileItemGroup">
        <div
          class="display-flex-space-between flex-align-center menuMobileItem"
          (click)="
            action(
              'myLtiFormMobile',
              'planReviewMobile',
              'PARTECIPANT_LTI.DOCUMENTS.MY_LTI_FORMS'
            )
          "
        >
          <div class="">
            {{
              'PARTECIPANT_LTI.DOCUMENTS.MY_LTI_FORMS' | translate | titlecase
            }}
          </div>
          <i class="fa fa-angle-right fa-2x"></i>
        </div>
      </div>
      <div class="menuMobileItemGroup">
        <div
          class="display-flex-space-between flex-align-center menuMobileItem"
          (click)="
            action(
              'terms&ConditionsMobile',
              'planReviewMobile',
              'PARTECIPANT_LTI.DOCUMENTS.TERMS_CONDITIONS'
            )
          "
        >
          <div class="">
            {{
              'PARTECIPANT_LTI.DOCUMENTS.TERMS_CONDITIONS'
                | translate
                | titlecase
            }}
          </div>
          <div class="display-flex-right flex-align-center">
            <i
              class="fa fa-info-circle fa-2x footer-default"
              *ngIf="!currentPlan.termsConditions"
            ></i>
            <div style="width: 10px"></div>
            <i class="fa fa-angle-right fa-2x"></i>
          </div>
        </div>
        <div
          class="display-flex-space-between flex-align-center menuMobileItem"
          (click)="
            action(
              'vexatiousClausesMobile',
              'planReviewMobile',
              'PARTECIPANT_LTI.DOCUMENTS.VEXATIOUS_CLAUSES'
            )
          "
        >
          <div class="">
            {{
              'PARTECIPANT_LTI.DOCUMENTS.VEXATIOUS_CLAUSES'
                | translate
                | titlecase
            }}
          </div>
          <div class="display-flex-right flex-align-center flex-align-center">
            <i
              class="fa fa-info-circle fa-2x footer-default"
              *ngIf="!currentPlan.vexatiousClauses"
            ></i>
            <div style="width: 10px"></div>
            <i class="fa fa-angle-right fa-2x"></i>
          </div>
        </div>
      </div>
      <div class="menuMobileItemGroup">
        <div
          class="display-flex-space-between flex-align-center menuMobileItem"
          *ngIf="currentPlan.Gateways && currentPlan.Gateways.length > 0"
          (click)="
            action(
              'gatewaysMobile',
              'planReviewMobile',
              'ADMIN_LTI.TABS.GATEWAYS'
            )
          "
        >
          <div class="">
            {{ 'ADMIN_LTI.TABS.GATEWAYS' | translate | titlecase }}
          </div>
          <i class="fa fa-angle-right fa-2x"></i>
        </div>
        <div
          class="display-flex-space-between flex-align-center menuMobileItem"
          *ngIf="currentPlan.Objectives && currentPlan.Objectives.length > 0"
          (click)="
            action(
              'objectivesMobile',
              'planReviewMobile',
              'ADMIN_LTI.TABS.OBJECTIVES'
            )
          "
        >
          <div class="">
            {{ 'ADMIN_LTI.TABS.OBJECTIVES' | translate | titlecase }}
          </div>
          <i class="fa fa-angle-right fa-2x"></i>
        </div>

        <div
          class="display-flex-space-between flex-align-center menuMobileItem"
          *ngIf="currentPlan.Correctives && currentPlan.Correctives.length > 0"
          (click)="
            action(
              'bonusBankCorrectiveMobile',
              'planReviewMobile',
              'ADMIN_LTI.RESULTS.BONUS_BANK_CORRECTIVES'
            )
          "
        >
          <div class="">
            {{
              'ADMIN_LTI.RESULTS.BONUS_BANK_CORRECTIVES' | translate | titlecase
            }}
          </div>
          <i class="fa fa-angle-right fa-2x"></i>
        </div>
      </div>
      <!-- <div class="menuMobileItemGroup">
        <div class="display-flex-space-between flex-align-center menuMobileItem" (click)="action('targetBonusMobile', 'planReviewMobile', 'PARTECIPANT_LTI.SIDEBAR.TARGET_BONUS')">
          <div class="">{{'PARTECIPANT_LTI.SIDEBAR.TARGET_BONUS' | translate | titlecase}}</div>
          <i class="fa fa-angle-right fa-2x"></i>
        </div>
        <div class="display-flex-space-between flex-align-center menuMobileItem" (click)="action('payoutStructureMobile', 'planReviewMobile', 'PARTECIPANT_LTI.SIDEBAR.PAYOUT_STRUCTURE')">
          <div class="">{{'PARTECIPANT_LTI.SIDEBAR.PAYOUT_STRUCTURE' | translate | titlecase}}</div>
          <i class="fa fa-angle-right fa-2x"></i>
        </div>
      </div> -->
      <!-- <div class="menuMobileItemGroup">
        <div class="display-flex-space-between flex-align-center menuMobileItem" (click)="action('glossaryMobile', 'planReviewMobile', 'PARTECIPANT_LTI.SIDEBAR.GLOSSARY')">
          <div class="">{{'PARTECIPANT_LTI.SIDEBAR.GLOSSARY' | translate | titlecase}}</div>
          <i class="fa fa-angle-right fa-2x"></i>
        </div>
      </div> -->
    </div>
    <div class="menuMobileItemGroup" *ngIf="!currentPlan.acceptedPlan">
      <div
        class="bigYellowButton"
        (click)="accept()"
        [ngClass]="{
          disabled:
            !currentPlan.termsConditions ||
            !currentPlan.myLtiFormMobile ||
            !currentPlan.vexatiousClauses
        }"
      >
        {{ 'PARTECIPANT_LTI.DOCUMENTS.ACCEPT_PLAN' | translate | uppercase }}
      </div>
    </div>
  </div>

  <div class="menuMobileItemGroup" *ngIf="currentView == 'resultsMobile'">
    <div
      class="display-flex-space-between flex-align-center menuMobileItem"
      (click)="
        action(
          'bonusAccruedWidgetMobile',
          'resultsMobile',
          'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TITLE'
        )
      "
    >
      <div class="">
        {{
          'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TITLE'
            | translate
            | titlecase
        }}
      </div>
      <i class="fa fa-angle-right fa-2x"></i>
    </div>
    <div
      class="display-flex-space-between flex-align-center menuMobileItem"
      (click)="
        action(
          'bonusBankWidgetMobile',
          'resultsMobile',
          'PARTECIPANT_LTI.RESULTS.BONUS_BANK_WIDGET.TITLE'
        )
      "
    >
      <div class="">
        {{
          'PARTECIPANT_LTI.RESULTS.BONUS_BANK_WIDGET.TITLE'
            | translate
            | titlecase
        }}
      </div>
      <i class="fa fa-angle-right fa-2x"></i>
    </div>
    <div
      class="display-flex-space-between flex-align-center menuMobileItem"
      (click)="
        action(
          'bonusPayableWidgetMobile',
          'resultsMobile',
          'PARTECIPANT_LTI.RESULTS.BONUS_PAYABLE_WIDGET.TITLE'
        )
      "
    >
      <div class="">
        {{
          'PARTECIPANT_LTI.RESULTS.BONUS_PAYABLE_WIDGET.TITLE'
            | translate
            | titlecase
        }}
      </div>
      <i class="fa fa-angle-right fa-2x"></i>
    </div>
  </div>
</div>
